import { z } from "zod";

export const membershipFormSchema = z.object({
  sacco_name: z.string().min(1, "Sacco name is required"),
  membership_number: z.string().min(1, "Membership number is required"),
  phone: z.string().optional(),
  email: z.string().email("Invalid email address").optional().or(z.literal("")),
  address: z.string().optional(),
  notes: z.string().optional(),
  currency: z.string().min(1, "Currency is required"),
});

export type MembershipFormValues = z.infer<typeof membershipFormSchema>;
